import PropTypes from "prop-types";
import React from "react";

import emptyStateIcon from "../../assets/images/user-dashboard/placeholder.svg";

/* -------------------------------------------------------------------------
 * EmptyState — consistent empty state component with icon and styling
 * Used across customer-facing pages when no data is available
 * ---------------------------------------------------------------------- */

const EmptyState = ({ icon, title, message, actionText, onAction }) => {
  return (
    <div className="empty-state">
      <div className="empty-state__icon">
        <img src={icon || emptyStateIcon} alt="Empty state" />
      </div>
      <h3 className="empty-state__title">{title}</h3>
      <p className="empty-state__message">{message}</p>
      {actionText && onAction && (
        <button type="button" className="empty-state__action" onClick={onAction}>
          {actionText}
        </button>
      )}
    </div>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  actionText: PropTypes.string,
  onAction: PropTypes.func,
};

EmptyState.defaultProps = {
  icon: null,
  actionText: null,
  onAction: null,
};

export default EmptyState;
